/* eslint-disable react/destructuring-assignment */
import * as React from 'react';
import { RenderElementProps } from 'slate-react';

import { RenderElement, SlatePlugin } from '../types';

const EditorSlowElementBase = ({ elementProps, plugins, renderElementList, renderDragElement }) => {
  let element;

  renderElementList.some((renderElement) => {
    element = renderElement(elementProps);
    return !!element;
  });

  if (element) return element;

  plugins.some(({ renderElement }) => {
    element = renderElement && renderElement(elementProps);
    return !!element;
  });
  if (renderDragElement && element) {
    return renderDragElement({
      children: element,
      attributes: elementProps.attributes,
      element: elementProps.element,
    });
  }
  if (element) return element;
  if (renderDragElement) {
    return renderDragElement({
      children: elementProps.children,
      attributes: elementProps.attributes,
      element: elementProps.element,
    });
  }
  return <div {...elementProps.attributes}>{elementProps.children}</div>;
};

const EditorSlowElement = React.memo(EditorSlowElementBase);

export const renderElementPlugins = (
  plugins: SlatePlugin[],
  renderElementList: RenderElement[],
  renderDragElement: ({ element, children, attributes }) => JSX.Element
) => {
  return (elementProps: RenderElementProps) => {
    return (
      <EditorSlowElement
        elementProps={elementProps}
        plugins={plugins}
        renderElementList={renderElementList}
        renderDragElement={renderDragElement}
      />
    );
  };
};
